// app/javascript/controllers/dae20/tmc_snapshot_controller.js
import { Controller } from "@hotwired/stimulus"

/**
 * Stimulus Controller для компонента tmc_snapshot.
 *
 * Функции:
 * - POST /dae20/tmc_snapshots/:component_id/create — фиксация снимка
 * - Отображение результата (успех/ошибка)
 * - Блокировка кнопки на время запроса
 */
export default class extends Controller {
  static targets = ["snapshotBtn", "result", "commentInput"]

  static values = {
    componentId: String,
    tmcUid: String,
    templateId: String,
    pageId: String
  }

  get csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ""
  }

  async createSnapshot(event) {
    event.preventDefault()

    if (!this.tmcUidValue) {
      this.showResult("error", "Не определён ТМЦ — откройте карточку через поиск")
      return
    }

    // Заблокируем кнопку
    if (this.hasSnapshotBtnTarget) {
      this.snapshotBtnTarget.disabled = true
      this.snapshotBtnTarget.textContent = "Фиксация..."
    }
    this.showResult("info", "Создание снимка...")

    try {
      const url = `/dae20/tmc_snapshots/${this.componentIdValue}/create`
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken
        },
        credentials: "same-origin",
        body: JSON.stringify({
          tmc_uid: this.tmcUidValue,
          template_id: this.templateIdValue,
          page_id: this.pageIdValue,
          comment: this.hasCommentInputTarget ? this.commentInputTarget.value.trim() : ""
        })
      })

      const data = await response.json()

      if (data.ok) {
        this.showResult("success",
          `Снимок #${data.snapshot_number} создан (${data.snapshot_name})`
        )
        // Очистим поле комментария
        if (this.hasCommentInputTarget) {
          this.commentInputTarget.value = ""
        }
        // Перезагрузим таблицу истории если она на той же странице
        this.reloadHistoryTable()
      } else {
        const errors = (data.errors || []).join(", ")
        this.showResult("error", `Ошибка: ${errors}`)
      }
    } catch (error) {
      this.showResult("error", `Сетевая ошибка: ${error.message}`)
    } finally {
      if (this.hasSnapshotBtnTarget) {
        this.snapshotBtnTarget.disabled = false
        this.snapshotBtnTarget.textContent = "Зафиксировать снимок"
      }
    }
  }

  showResult(type, message) {
    if (!this.hasResultTarget) return

    const colors = {
      success: "text-green-700 bg-green-50 border-green-200",
      error: "text-red-700 bg-red-50 border-red-200",
      info: "text-blue-700 bg-blue-50 border-blue-200"
    }
    const colorClass = colors[type] || colors.info

    this.resultTarget.innerHTML =
      `<div class="px-3 py-2 rounded-lg border text-xs ${colorClass}">${message}</div>`
  }

  reloadHistoryTable() {
    // Ищем Turbo Frame таблицы истории на странице и перезагружаем
    const tables = document.querySelectorAll('[data-component-type="table"]')
    tables.forEach(table => {
      const frame = table.closest('turbo-frame')
      if (frame && frame.src) {
        frame.reload()
      }
    })
  }
}
